<template>
    <div class="yh-page">
      <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
        <el-form :rules="rules" ref="dataForm" :model="crew_from" label-position="right" label-width="160px">
        <!-- 联系人信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">船员信息</span></el-divider>
            </el-col>
          </el-row>
  
          <el-row>
            <el-col :span="12">
              <!-- 姓名 -->
              <el-form-item label="姓名" prop="name">
                <el-input v-model="crew_from.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 证件号码 -->
              <el-form-item label="证件号码" prop="cert_number">
                <el-input v-model="crew_from.cert_number" placeholder="请输入证件号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 手机号 -->
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="crew_from.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 固话-->
              <el-form-item label="固定电话" prop="phone">
                <el-input v-model="crew_from.ext_info.phone" placeholder="请输入固定电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 邮箱 -->
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="crew_from.ext_info.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 微信 -->
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="crew_from.ext_info.wechat" maxlength="11" placeholder="请输入微信号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 地址-->
              <el-form-item label="地址" prop="address">
                <el-input v-model="crew_from.ext_info.address" placeholder="请输入地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="opera_type == 'Update'">
                    <!-- 身份证明文件 -->
                    <el-form-item label="船员" prop="attachments">
                    <attachment-list 
                        object-type="member.member" :object-id="crew_from.id" :file-list="file_list"
                        :attachment-name="attachment_name"
                        @removed="loadFileList('crew.crew', crew_from.id)"></attachment-list>
                    <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                    </el-form-item>
                </el-col>
            <!-- 管理人-->

          </el-row>

               <!-- 绑定客户信息 ------------------------------------------------------------------------------ -->
          <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">船员服务记录</span></el-divider>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="22">
              <el-table :key="0" :data="service_list" stripe fit class="w-100">
                <!-- 服务记录 -->
                <el-table-column align="left" label="船舶" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.ship_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="职位" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.position}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="开始时间" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.start_date}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="结束时间" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.end_date}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="上船地点" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.start_place}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="离船地点" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.end_place}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="薪资" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{scope.row.wage}}</span>
                  </template>
                </el-table-column>
     
                <!-- 按钮组 -->
                <el-table-column align="left" label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                      <el-button
                                type="text" @click="handleEditService(scope.row)"><i class="el-icon-edit"></i></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                      <el-button
                                type="text" @click="handleDeleteService(scope.row)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

        <!-- 操作 ------------------------------------------------------------------------------ -->
        <el-row class="el-row-divider">
            <el-col :span="22" >
              <el-divider content-position="left"><span class="title">操作</span></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" >
              <el-form-item>
                <el-button @click="() => {this.$router.go(-1)}">取消</el-button>
                <el-button v-if="opera_type == 'Update' && $perm(['crew.change_crew'])" 
                           type="primary" @click="updateData">保存
                </el-button>
                <template v-if="opera_type == 'Create' && $perm(['crew.add_crew'])">
                  <el-button type="primary" @click="createData(1)">保存</el-button>
                </template>
                <el-button type="primary" size="small"  @click="handleAddService" v-if="opera_type == 'Update'">新增记录</el-button>
              </el-form-item>
            </el-col>
              
          </el-row>
        </el-form>

        <el-dialog :visible.sync="serviceVisible" width="50%">
            <el-form label-width="120px">
            <el-form-item label="选择船舶" v-if="service_opear_type !== 'update'">
                <el-select v-model="service_form.ship_id" placeholder="请选择船舶"
                  filterable value-key="id"
                  remote :remote-method="remoteShipMethod" :loading="ship_loading"
                >
                  <el-option v-for="s in ships" :key="s.id"
                      :label="s.name" :value="s.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
                <el-date-picker type="date" placeholder="选择日期" v-model="service_form.start_date"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
                <el-date-picker type="date" placeholder="选择日期" v-model="service_form.end_date"></el-date-picker>
              </el-form-item>
            <el-form-item label="上船地点" width="50%">
                <el-input maxlength="64" v-model="service_form.start_place"></el-input>
            </el-form-item>
            <el-form-item label="离船地点" width="50%">
                <el-input maxlength="64" v-model="service_form.end_place"></el-input>
            </el-form-item>
            <el-form-item label="职位" width="50%">
                <el-input maxlength="64" v-model="service_form.position"></el-input>
            </el-form-item>
            <el-form-item label="薪资" width="50%">
                <el-input type="number" v-model="service_form.wage"></el-input>
            </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addService" v-if="service_opear_type === 'create'">确 定</el-button>
                <el-button type="primary" @click="updateService" v-if="service_opear_type === 'update'">确 定</el-button>
            </span>

        </el-dialog>


        <upload-dialog ref="upload" :object-name="crew_from.name" :file-type-list="file_type_list"
                object-type="crew.crew" :object-id="crew_from.id" :append-to-body="true"
                @appended="handleAppended" @uploaded="loadFileList('crew.crew', crew_from.id)">
            </upload-dialog>
      </el-card>
    </div>
  </template>
  <script>

import {parseTime} from '@/utils'
import {isValidMobileNumber} from '@/utils/validate'
import { fetchShipNameList} from '@/api/ship'
import UploadDialog from "@/components/UploadDialog"
import AttachmentList from "@/components/AttachmentList"
import {getCrewInfo,CreateCrew,UpdateCrew,getCrewServiceList,CreateCrewService,UpdateCrewService,deleteCrewService,getServiceInfo} from '@/api/crew'
import { fetchFileTypeList,getObjectFileAll } from '@/api/common'
  
    export default {
      name: "crewDetail",
      components: {
        UploadDialog,
        AttachmentList,
      },
      computed: {
      },
      data() {
        var checkMobile = (rule, value, callback) => {
              if (!isValidMobileNumber(value)) {
                return callback(new Error('手机格式不正确'))
              }
              return callback();
        };
        var checkCertNumber = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('身份证号码不能为空'));
            }

            var msg, boo; //  msg身份证验证友情提示,boo返回值
            var value = value.toUpperCase(); // 身份证为末尾可能是X
            //   身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，
            //   最后一位是校验位，可能为数字或字符X。
            const arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            const arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
            var nTemp = 0,
                i;
            if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
                //  输入的身份证号长度不对，或者号码不符合规定;
                return callback(new Error('输入的身份证号长度不对，或者号码不符合规定'))
            }
            //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            //   下面分别分析出生日期和校验位
            var len, re;
            len = value.length;
            if (len == 15) {
                re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
                var arrSplit = value.match(re);
                //   检查生日日期是否正确
                var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
                var bGoodDay;
                bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
                if (!bGoodDay) {
                //   输入的身份证号里出生日期不对！
                return callback(new Error('输入的身份证号里出生日期不对！'))

                } else {
                //   将15位身份证转成18位
                //   校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。   
                value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
                for (i = 0; i < 17; i++) {
                    nTemp += value.substr(i, 1) * arrInt[i];
                }
                value += arrCh[nTemp % 11];
                return callback()
                }
            }
            if (len == 18) {
                re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
                var arrSplit = value.match(re);
                //  检查生日日期是否正确
                var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
                var bGoodDay;
                bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
                if (!bGoodDay) {
                //  输入的身份证号里出生日期不对！ 

                return callback(new Error('输入的身份证号里出生日期不对！'))
                } else {
                //  检验18位身份证的校验码是否正确。
                //  校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
                var valnum;
                for (i = 0; i < 17; i++) {
                    nTemp += value.substr(i, 1) * arrInt[i];
                }
                valnum = arrCh[nTemp % 11];
                if (valnum != value.substr(17, 1)) {
                    //  18位身份证的校验码不正确！
                    return callback(new Error('身份证的校验码不正确！'))
                }
                return callback()
                }
            }
            return callback(new Error('身份证的长度不正确！'))
        };

        return {
          rules: {
            cert_number: [{required: true, validator: checkCertNumber, trigger: 'blur'}],
            mobile: [{required: true,validator: checkMobile, trigger: 'blur'}],
            name: [{required: 'true'}],
          },
          loading: false,
          serviceVisible:false,
          ship_loading:false,
          service_opear_type:'',
          file_list:[],
          file_type_list:[],
          ships: [],
          service_list:[],
          loadingText: '正在加载数据，请销等...',
          crew_from:{
            ext_info:{},
            name:null,
            mobile:null,
            cert_number:null
            },
          service_form:{ext_info:{}},
          opera_type:'',
        }
      },
      computed: {
        attachment_name: function () {
        let name = this.crew_from.name
        return (name + ".zip");
        }
      },
      methods: {
        handleDeleteService(row){        
            this.$confirm('是否删除该船员记录', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                deleteCrewService({id:row.id}).then(res => {
                this.$message({type: 'success', message: '删除成功!'})
                this.getServiceList()
            }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
        updateService(row){
            if (!this.service_form.start_date){
              this.$error_message("请选择开始时间！")
              return
            }
            UpdateCrewService(this.service_form).then(res => {
                this.$message({type: 'success', message: '更新成功!'})
                this.serviceVisible = false
                this.getServiceList()
            }).catch(err => {
                this.$message.error(err)
            })
        },
        handleEditService(row){
            this.service_opear_type = 'update'
            getServiceInfo({'id':row.id}).then(res => {
                this.service_form = res
            }).catch(err => {
                this.$message.error(err)
            })
            this.serviceVisible = true
        },
        getServiceList(){
            getCrewServiceList({'crew_id':this.id}).then(res => {
                this.service_list = res
            }).catch(err => {
                this.$message.error(err)
            })
        },
        addService(){
            this.service_form.crew_id = this.id
            if (!this.service_form.ship_id){
              this.$error_message("请选择船舶！")
              return
            }
            if (!this.service_form.start_date){
              this.$error_message("请选择开始时间！")
              return
            }
            CreateCrewService(this.service_form).then(res => {
                this.$message({type: 'success', message: '创建成功!'})
                this.serviceVisible = false
                this.getServiceList()
            }).catch(err => {
                this.$message.error(err)
            })
        },
        handleAddService(){
            this.service_opear_type = 'create'
            this.service_form = {}
            this.serviceVisible = true
        },
        updateData(){
            this.crew_from.id = this.id
            this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              UpdateCrew(this.crew_from).then(res => {
                    this.$message({type: 'success', message: '更新船员信息成功!'})
                    this.$router.push({ name: 'crewList'})
                }).catch(err => {
                    this.$message.error(err)
                })
            }
            })

        },
        createData(){
            this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                CreateCrew(this.crew_from).then(res => {
                this.$message({type: 'success', message: '创建船员成功!'})
                this.$router.push({ name: 'crewList'})
            }).catch(err => {
                this.$message.error(err)
            })
            }
            })
        },
        remoteShipMethod(query) {
        if (query !== '') {
          this.ship_loading = true
          setTimeout(() => {
            fetchShipNameList({'search': query}).then(res => {
              this.ships = res
              this.ship_loading = false
            }).catch(err => {
              this.ship_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.ships = [];
        }
      },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
            getObjectFileAll(object_type, object_id).then(res => {
                this.file_list = res
                this.file_list.forEach(item => {
                    this.$set(item, 'checked', true)
                })
            })
            .catch(error => {
                this.$error_message(error)
            })
        },
        loadData() {
            getCrewInfo({'id': this.id}).then(res => {
                this.crew_from  = res
            }).catch(err => {
                this.$message.error(err)
            })
            if (this.opear_type  === 'Update'){
                this.loadFileList('crew.crew', this.id)
            }
            this.getServiceList()
            let p0 = fetchFileTypeList({ file_type: "bc|cc" })
            Promise.all([p0])
                .then(res => {
 
                this.file_type_list = res[0]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },
      },
      beforeRouteLeave (to, from, next) {
          if (to.name != 'crewList') {
            window.localStorage.removeItem('query')
          }
          next()
          },
      created() {
        this.opera_type = this.$route.query.type
            if (['View', 'Update'].indexOf(this.opera_type) !== -1) {
          this.id = this.$route.query.id
          if (this.id == undefined) {
            this.$router.push('/404')
          } else {
            this.loadData()
          }
        }
      }
    }
  </script>
  
  <style scoped>
  .el-row-divider {
    margin-top: 36px
  }
  
  .title {
    font-weight: bold;
  }
  
  .highlight {
    color:red;
  }
  
  </style>      